import { Component, ViewChild } from '@angular/core';
import { App,Nav, Platform,Loading, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { MsgProvider } from '../providers/msg/msg';

import { LoginsPage } from '../pages/logins/logins';
import {UploadPage} from '../pages/upload/upload';
import { timer } from 'rxjs/observable/timer';
import { Storage } from '@ionic/storage';
import { LaporanPage } from '../pages/laporan/laporan';
import { BerandaPage } from '../pages/beranda/beranda';
import { ApiProvider } from '../providers/api/api';
import { FinstalasihdPage } from '../pages/finstalasihd/finstalasihd';
import { CodePush, InstallMode, SyncStatus } from '@ionic-native/code-push';
//import { DatabaseProvider } from '../providers/database/database';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  loading:Loading;
  rootPage: any = LoginsPage;
  showSplash = true;

  pages: Array<{title: string, component: any}>;

  constructor(
    //public db:DatabaseProvider,
    private msg:MsgProvider,
    private storage:Storage,
    public platform: Platform, 
    public statusBar: StatusBar,
    private loadingCtrl:LoadingController, 
    private app:App,
    private codePush: CodePush,
    private api:ApiProvider,
    public splashScreen: SplashScreen) {
    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Home', component: BerandaPage },
      { title: 'Instalasi', component: FinstalasihdPage },
    //  { title: 'Laporan', component: LaporanPage },
     // { title: 'upload', component:UploadPage},
      { title: 'Logout', component: null }
    ];

  }

  checkCodePush() {
    
    this.codePush.sync({
     updateDialog: {
      appendReleaseDescription: true,
      descriptionPrefix: "\n\nKeterangan Update:\n"   
     },
     installMode: InstallMode.IMMEDIATE
  }).subscribe(
    (data) => {
     console.log('CODE PUSH SUCCESSFUL: ' + data);
     
    },
    (err) => {
     console.log('CODE PUSH ERROR: ' + err);
     
    }
  );
 }

  initializeApp() {
    this.platform.ready().then(() => {
      this.checkCodePush();
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      timer(5000).subscribe(() => this.showSplash = false)
    });
  }
  dissmissloading(){
    if(this.loading){
        this.loading.dismiss();
        this.loading = null;
    }
  }
  createLoader(message: any) {
    this.loading = this.loadingCtrl.create({
      content: message
    });
  }
  ngOnInit() { 
    this.createLoader('Please wait ...');
    this.loading.present().then(() => {
      this.api.postData().then((result) => {
        if(result["message"] == true){
        //  this.db.createTable();
          this.storage.set('dynamicurl_utama',result["data"].url);
          this.storage.set('apikeyaccess',result["data"].apikeyaccess);
          this.storage.set('module_endpoint',result["data"].module);
          this.storage.get('userdatateknisi').then((val) => {
            if (val != null) { 
              this.dissmissloading();
              this.app.getRootNav().setRoot(BerandaPage);
            } else {
              this.dissmissloading();
              this.app.getRootNav().setRoot(LoginsPage);  
            }
          },(err) => {
            this.dissmissloading();
            this.msg.msg_plainmsg(err);
          }); 
        }else{
          this.dissmissloading();
          this.msg.msg_plainmsg('Enable get url, please call your IT Support');
        }
        this.dissmissloading();
      });
    setTimeout(() => {
        this.dissmissloading();
      }, 10000);
    }, (err) => {
      this.dissmissloading();
      this.msg.msg_plainmsg(err);
    });
  }
 
  openPage(page) {
    if(page.component){
      this.nav.setRoot(page.component);
    }else{
      this.storage.clear();
      localStorage.removeItem('datawoinstalasi');
      this.app.getRootNav().setRoot(LoginsPage);
    } 
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts